<template>
  <div id="app">
    <!--导航条-->
    <!--<gheader></gheader>-->
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav></grednav>
    <!--主要内容展示-->
    <div class="row-content">
      <div class="main-width">
        <div class="project-sort pull-left">
          <lnav ref="lnav" v-on:filtrate="showCondition"></lnav>
        </div>
        <div class="notice-content pull-right">
          <showtable ref="showtable" v-bind:captionTitle="captionTitle" v-bind:condition="checked" v-bind:dataUrl="tableDataUrl"></showtable>
        </div>
      </div>
    </div>
    <!--合作供应商-->
    <gsupplier></gsupplier>
    <!--footer-->
    <gfooter></gfooter>
  </div>
</template>

<script>
  import gheader from 'components/G-header'
  import glogo from 'components/G-logo'
  import grednav from 'components/G-rednav'
  import gsupplier from 'components/G-supplier'
  import gfooter from 'components/G-footer'
  import lnav from 'components/L-nav'
  import showtable from 'components/show-table'
  import underdesign from 'components/underdesign'
  import {apiLinks} from '../../api/links'

  export default {
    name: 'app',
    components: {
      gheader,
      glogo,
      grednav,
      gsupplier,
      gfooter,
      lnav,
      showtable,
      underdesign
    },
    data () {
      return {
        links: {
          title: '友情链接',
          content: [
            '南方水泥官方网站',
            '中国建筑材料集团有限公司',
            '中国建材股份有限公司',
            '南方水泥有限公司成员企业'
          ]
        },
        captionTitle: [
          '询价公告',
          '招标公告',
          '中标公告'
        ],
        checked: '',
        tableDataUrl: apiLinks.logisticstableDate
      }
    },
    methods: {
      showCondition: function () {
        this.checked = this.$refs.lnav.condition
      }
    }
  }
</script>
<style>
  @import 'logistics.css';
</style>



// WEBPACK FOOTER //
// logistics.vue?6612eb98